import React from 'react';
import cn from 'classnames';

type CheckboxProps = {
  id: string
  label?: React.ReactNode
  checked?: boolean
  indeterminate?: boolean
  className?: string
  onChange?: (id: string) => void
};

export default function UICheckbox({
  id, label, checked = false, indeterminate = false, className, onChange,
}: CheckboxProps) {
  const handleOnChange = () => {
    if (onChange) {
      onChange(id);
    }
  };

  return (
    <div className={cn('flex items-center mb-2', className)}>
      {/* eslint-disable-next-line no-param-reassign,no-return-assign */}
      <input id={id} name={id} ref={(el) => el && (el.indeterminate = indeterminate)}
        checked={checked}
        type="checkbox"
        className="h-5 w-5 text-blue border-gray rounded focus:ring-0 focus:ring-offset-0 cursor-pointer"
        onChange={handleOnChange}
      />
      {label &&
      <label htmlFor={id} className="ml-2 block cursor-pointer">
        {label}
      </label>
      }
    </div>
  );
}

